var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-video__wrap" },
    [
      _vm.heading ? _c("h3", [_vm._v(_vm._s(_vm.heading))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-video responsive-embed widescreen" },
        [
          _c("uc-media-button", {
            class: { "c-media-button--hidden": !_vm.showOverlay },
            attrs: {
              callback: _vm.playVideo,
              duration: _vm.duration,
              tag: "button",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-video__overlay",
              class: { "c-video__overlay--visible": _vm.showOverlay },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.playVideo.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                staticClass: "c-video__thumbnail lazyload",
                attrs: { "data-src": _vm.getPoster, alt: "" },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "c-video__sharing",
                  attrs: {
                    href: "#",
                    "aria-label": "Click to view on YouTube",
                    alt: "View on YouTube",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.handleShare.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("uc-icon", {
                    attrs: { glyph: "share", alt: "View on YouTube Icon" },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-video__embed responsive-embed widescreen",
              class: { "c-video__embed--visible": _vm.showVideo },
            },
            [
              _c("youtube", {
                ref: "youtube",
                attrs: {
                  "video-id": _vm.videoid,
                  width: "100%",
                  height: "100%",
                },
                on: { playing: _vm.playing },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.description || _vm.credit
        ? _c("uc-caption", {
            attrs: { description: _vm.description, credit: _vm.credit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }